export class Language {
  private _language: string;
  private twoLetterCountryCodeLength = 2;
  private lcidDecimal = 4;
  private lcidString = 5;

  get language(): string {
    return this._language;
  }

  constructor(language: string) {
    if (language.length === this.twoLetterCountryCodeLength || language.length === this.lcidString) {
      this._language = language.toLowerCase().substring(0, 2);
    } else if (language.length === this.lcidDecimal && !isNaN(+language)) {
      switch (+language) {
        case 1033:
        case 2057:
          this._language = 'en';
          break;
        case 1043:
        case 2067:
          this._language = 'nl';
          break;
        case 1036:
        case 2060:
          this._language = 'fr';
          break;
        case 3079:
        case 1031:
        case 5127:
        case 4103:
        case 2055:
          this._language = 'de';
          break;
        case 1030:
          this._language = 'da';
          break;
      }
    }
  }
}
